var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeycard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1203,
    height: 840,
    viewBox: "0 0 1203 840",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3046_440)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1203,
    height: 840,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 197.508C0 159.692 29.9098 129.054 66.826 129.054H1136.17C1173.09 129.054 1203 159.692 1203 197.508V771.546C1203 809.362 1173.09 840 1136.17 840H66.826C29.9098 840 0 809.362 0 771.546V197.508Z",
    fill: "url(#paint0_diamond_3046_440)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.019 286C144.957 286 170.037 260.928 170.037 230C170.037 199.072 144.957 174 114.019 174C83.0804 174 58 199.072 58 230C58 260.928 83.0804 286 114.019 286Z",
    fill: "#C00824"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.05 237.925L97.7241 221.371V258.881H84.7764V201.12H97.9883L121.946 227.623L113.05 237.925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.049 201.12H143.261V258.881H130.314V201.12",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.394 201.12H195.228L212.844 228.415L230.46 201.12H241.294V258.881H231.165V217.497L212.932 244.704H212.58L194.523 217.585V258.881H184.394V201.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.22 210.541H247.9V201.12H294.846V210.541H276.526V258.881H266.309V210.541H266.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.717 201.12H311.846V258.881H301.717V201.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1113.63 213.995C1118.76 216.5 1122.36 222.222 1122.36 228.891C1122.36 234.917 1119.42 240.063 1115.09 242.907L1118.72 249.982C1125.23 245.75 1129.63 237.93 1129.63 228.891C1129.63 219.852 1125.5 212.471 1119.29 208.172L1113.63 213.995ZM1096.35 208.172C1090.14 212.471 1086.01 220.156 1086.01 228.891C1086.01 237.625 1090.4 245.75 1096.91 249.982L1100.55 242.907C1096.22 240.063 1093.28 234.917 1093.28 228.891C1093.28 222.222 1096.85 216.5 1102 213.995L1096.35 208.172ZM1090.86 202.484C1083.53 208.375 1078.73 217.99 1078.73 228.891C1078.73 240.909 1084.58 251.337 1093.24 256.99L1089.61 264.032C1078.77 256.99 1071.46 243.922 1071.46 228.891C1071.46 215.891 1076.95 204.312 1085.44 196.898L1090.86 202.518V202.484ZM1124.77 202.484C1132.11 208.375 1136.9 217.99 1136.9 228.891C1136.9 240.909 1131.05 251.337 1122.36 256.99L1125.99 264.032C1136.87 256.99 1144.17 243.922 1144.17 228.891C1144.17 215.891 1138.69 204.312 1130.19 196.898L1124.77 202.518V202.484ZM1100.55 228.891C1100.55 224.422 1103.82 220.766 1107.82 220.766C1111.82 220.766 1115.09 224.422 1115.09 228.891C1115.09 233.36 1111.82 237.016 1107.82 237.016C1103.82 237.016 1100.55 233.36 1100.55 228.891Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_3046_440",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(601.5 484.527) rotate(90) scale(355.473 601.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#294979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3760"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3046_440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1203,
    height: 840,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeycard);
export default __webpack_public_path__ + "static/media/keycard.32a815c628b8b156cc46989aa386c56b.svg";
export { ForwardRef as ReactComponent };